/**
 * PortalSettings — client-portal-facing settings screen.
 * Renders the shared NotificationPrefsCard filtered to the four
 * report kinds a client actually cares about (Incident / Maintenance
 * / DAR / Tour), plus per-site mute toggles.
 * Wrapped in PortalLayout so the sidebar + branding stay portal-native.
 */
import PortalLayout from "../components/PortalLayout";
import { PageHeader } from "../components/Primitives";
import { NotificationPrefsCard, MutedSitesCard } from "../components/NotificationPrefsCard";

const PORTAL_EVENT_KEYS = ["incident", "maintenance", "dar", "tour"];

export default function PortalSettings() {
  return (
    <PortalLayout>
      <div>
        <PageHeader
          title="Settings"
          subtitle="How and when Iris Security emails you about activity on your sites."
        />
        <div className="p-8 space-y-6 max-w-3xl">
          <div data-testid="portal-notif-prefs">
            <NotificationPrefsCard eventFilter={PORTAL_EVENT_KEYS} />
          </div>
          <MutedSitesCard />
        </div>
      </div>
    </PortalLayout>
  );
}
